// extracted by mini-css-extract-plugin
export default {"agGridContainer":"addJurisdictionsModal_agGridContainer__VVVLE","addJurisdictionModal":"addJurisdictionsModal_addJurisdictionModal__WnDGI"};